import { conferenceLeft, leaveConference } from '../../../react/features/base/conference/actions.any';
import { setIAmVisitor } from '../../../react/features/visitors/actions';
import { showDialogReJoin } from '../../functions.any';
import { LOGOUT_FROM_WIZYCONF_ROOM } from '../../wizyconf/constants';
export function wildixRemoveFromConferenceByPlatform() {
    return async (dispatch, getState) => {
        const state = getState();
        const { conference } = state['features/base/conference'] || {};
        dispatch(setIAmVisitor(false));
        if (navigator.product === 'ReactNative') {
            dispatch(conferenceLeft(conference));
            return;
        }
        else if (typeof APP !== 'undefined' && APP.wildix.wizy) {
            window.postMessage(LOGOUT_FROM_WIZYCONF_ROOM, '*');
            return;
        }
        showDialogReJoin();
        dispatch(leaveConference());
    };
}
